import { onDemand } from '@/utils/onDemand';

export default ({ app }, inject) => {
  // const script = document.createElement('script')
  // script.src = 'https://assets.calendly.com/assets/external/widget.js'
  // document.head.appendChild(script);
  // script.onload = () => {
  //   Calendly.initInlineWidget({
  //       url: 'https://calendly.com/anima-sales/zoom',
  //       parentElement: document.querySelector('.anima-calendly-widget'),
  //       prefill: {},
  //       utm: {}
  //   });
  // };

  // console.log('script load: ' + script.src)

  // const loader = new onDemand(
  //   'https://assets.calendly.com/assets/external/widget.js',
  //   false
  // );

  // console.log('calendly1')
  // inject('calendly', {
  //   init(params) {
  //     console.log('calendly3')
  //     loader.load(() => {
  //       console.log('calendly4')
  //       Calendly.initInlineWidget(params);
  //     });
  //   },
  // });
};
